module.exports = __webpack_public_path__ + "static/media/cusd.45c5902a.svg";